import { STEPS } from 'hb-react/shared/apps/Memberships/containers/PurchaseMembership/constants';
import { CART_ITEM_TYPES } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';

const stepIndexOf = (step) => Object.values(STEPS).findIndex((s) => s === step);

export const getBreadcrumbs = ({
  currentStep,
  setCurrentStep,
  withPaymentStep = true,
}) => {
  if (currentStep === STEPS.SUCCESS) {
    return;
  }

  const currentStepIdx = stepIndexOf(currentStep);

  return [
    {
      label: __('Registration'),
      onClickAction: () => {
        setCurrentStep(STEPS.REGISTRATION);
      },
      active: currentStepIdx === 0,
    },
    ...(withPaymentStep
      ? [
          {
            label: __('Billing Information'),
            onClickAction: () => {
              setCurrentStep(STEPS.BILLING);
            },
            active: currentStep === STEPS.BILLING,
            requiredExplanation: true,
            disable: currentStepIdx < stepIndexOf(STEPS.BILLING),
          },
          {
            label: __('Payment'),
            disable: true,
          },
        ]
      : []),
  ];
};

export const addShoppingCardItemsActions = ({
  item,
  currentPage,
  setCurrentStep,
  actions,
}) => {
  if (item.line_itemable_type === CART_ITEM_TYPES.DONATION) {
    return {
      ...item,
      ...(currentPage !== STEPS.SUCCESS
        ? {
            onEdit: () => {
              setCurrentStep(STEPS.DONATIONS);
            },
          }
        : []),
    };
  }

  if (item.line_itemable_type === CART_ITEM_TYPES.PROMO_CODE) {
    return {
      ...item,
      onDelete: () => {
        actions.items.remove(item.id);
      },
    };
  }

  return item;
};

export const getPromoCodeIds = (cartItems) =>
  cartItems
    .map((item) => {
      if (item.line_itemable_type === CART_ITEM_TYPES.PROMO_CODE) {
        return item.id;
      }

      return null;
    })
    .filter(Boolean);
